import React from "react";
import TableRowContainer from "../TableRowContainer";
import { icons } from "constants/icons";
import { ClinicType } from "types/Clinic";
import { ClinicUserInfo, StatusENUM } from "types/common";
import moment from "moment/moment";

type Props = {
  userId: string;
  clinic?: ClinicType;
  name: string;
  authStatus: string;
  role: string | undefined;
  status?: StatusENUM;
  disableUser: (userId: string, status?: StatusENUM) => void;
  editUser: (clinicId: string) => void;
  resendInvitation: (email: string, role: any) => void;
  profileInfo: ClinicUserInfo;
};

const TableRow = React.memo(
  ({
    userId,
    name,
    clinic,
    status,
    disableUser,
    profileInfo,
    role,
    resendInvitation,
    authStatus,
  }: Props) => {
    return (
      <>
        <TableRowContainer
          id={userId}
          authStatus={authStatus}
          onDisableUser={() => disableUser(userId, status)}
          resendInvitation={() => resendInvitation(profileInfo.email, role)}
          status={status}
          email={profileInfo.email}
        >
          <div className="w-[150px] ">
            <p>{name}</p>
          </div>

          <div className="w-[150px] ">
            {clinic?.name ? <p>{clinic?.name}</p> : <p>-</p>}
          </div>

          <div className="w-[150px] ">
            {clinic?.address ? <p>{clinic?.address}</p> : <p>-</p>}
          </div>
          <div className="w-[200px] pr-10">
            {role ? <p>{role}</p> : <p>-</p>}
          </div>
          <div className="w-[450px] pr-10 ">
            {profileInfo?.email ? <p>{profileInfo?.email}</p> : <p>-</p>}
          </div>
          <div className="w-[150px] pr-20 ">
            {profileInfo?.inviteDates?.length ? (
              <p>
                {profileInfo?.inviteDates
                  .map((date: string) => moment(date).format("L"))
                  .join(", ")}
              </p>
            ) : (
              <p>-</p>
            )}
          </div>

          <div className="w-[100px]">
            <img
              alt={""}
              src={
                status === StatusENUM.active
                  ? icons.clinicActiveStatus
                  : icons.clinicDisabledStatus
              }
            />
          </div>
        </TableRowContainer>
      </>
    );
  }
);

export default TableRow;
